import {LocaleComponentPicker} from '@frontend/modules/layout/LocaleComponentPicker'
import {VnCompanyLicenseLink} from './vn/VnCompanyLicenseLink'

// Ссылка на лицензию компании.
export function FooterCompanyLicenseLink() {

    return (
        <LocaleComponentPicker
            vn={<VnCompanyLicenseLink />}
            demo={<VnCompanyLicenseLink />}
        />
    )
}
